import { useLazyQuery } from '@apollo/client/react';
import { GetOrganizationDocument } from '@graphql/types';
import { useCallback } from 'react';

import type { GetOrganizationQuery } from '../types';

export const useGetOrganization = () => {
  const [refetch, { loading }] = useLazyQuery(GetOrganizationDocument);

  const doGetOrganization = useCallback(
    async (id: string): Promise<GetOrganizationQuery> => {
      const response = await refetch({
        variables: {
          id,
        },
      });

      if (!response.data) {
        throw new Error('Organization fetch failed');
      }

      return response.data;
    },
    [refetch]
  );

  return { doGetOrganization, loading };
};
